<template>
  <div>
    <div class="zrrlist">
      <!-- 耿彪增加 -->
      <div class="tit">
        <p>水毁工程修复情况</p>
      </div>
      <ul class="list listb">
        <li>
          <div>
            <p class="titnames">地市名称</p>
          </div>
          <div>
            <p class="titnames">水毁工程数量</p>
          </div>
          <div>
            <p class="titnames1">修复率</p>
          </div>
        </li>
      </ul>
      <ul class="list">
        <li v-for="(item,i) in shgcList" :key="i" :class="shgcList.length-1==i?'ddd':''">
          <div>
            <p class="titnames">{{item.city}}</p>
          </div>
          <div>
            <p class="titnames">{{item.sum}}</p>
          </div>
          <div>
            <p class="titnames1" :style="item.rate > 60 ? 'color:#ff6464' : 'color:lime'">{{item.rate}}%</p>
          </div>
        </li>
      </ul>
    </div>
    <div class="zrrlist">
      <div class="tit">
        <p>三个责任人落实情况</p>
      </div>
      <!-- 耿彪修改 -->
      <ul class="list listb">
        <li style="display: flex;">
          <div style="width:20%">
            <p class="titnames">地市名称</p>
          </div>
          <div style="width:20%">
            <p class="titnames">淤地坝数量</p>
          </div>
          <div style="width:20%">
            <p class="titnames">行政责任人</p>
          </div>
          <div style="width:20%">
            <p class="titnames">巡查责任人</p>
          </div>
          <div style="width:20%">
            <p class="titnames1">技术责任人</p>
          </div>
        </li>
      </ul>
      <ul class="list">
        <li v-for="(item,i) in practicablelist" :key="i" :class="practicablelist.length-1==i?'ddd':''" style="display: flex;">
          <div style="width:20%">
            <p class="titnames">{{item.city}}</p>
          </div>
          <div style="width:20%">
            <p class="titnames">{{item.sum}}</p>
          </div>
          <div style="width:20%">
            <p class="titnames">{{item.xzzrrSum}}</p>
          </div>
          <div style="width:20%">
            <p class="titnames">{{item.xczrrSum}}</p>
          </div>
          <div style="width:20%">
            <p class="titnames1">{{item.jsZrrSum}}</p>
          </div>
        </li>
      </ul>
    </div>
    <div class="zrrlist">
      <!-- 耿彪增加 -->
      <div class="tit">
        <p>隐患整改情况</p>
      </div>
      <ul class="list listb">
        <li style="display: flex;">
          <div style="width:25%">
            <p class="titnames">地市名称</p>
          </div>
          <div style="width:25%">
            <p class="titnames">隐患数量</p>
          </div>
          <div style="width:25%">
            <p class="titnames">已整改</p>
          </div>
          <div style="width:25%">
            <p class="titnames1">未整改</p>
          </div>
        </li>
      </ul>
      <ul class="list">
        <li v-for="(item,i) in levellist" :key="i" :class="levellist.length-1==i?'ddd':''" style="display: flex;">
          <div style="width:25%">
            <p class="titnames">{{item.city}}</p>
          </div>
          <div style="width:25%">
            <p class="titnames">{{item.sum}}</p>
          </div>
          <div style="width:25%">
            <p class="titnames" style="color:lime">{{item.ensure}}</p>
          </div>
          <div style="width:25%">
            <p class="titnames1" style="color:#ff6464">{{item.notSure}}</p>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  import {
    shgcxfqk,
    threeluoshi,
    yhgzqk,
    yhZhengg
  } from "@/api/api.js";
  export default {
    props: ["Nrssx"],
    data() {
      return {
        shgcList: [],
        practicablelist: [],
        levellist: [],
      };
    },
    mounted() {
      let params = {
        type: 0
      };
      this.shgcxfqkFun(params);
      this.yhgzqkFun(params);
      this.threeluoshiFun(params);
    },
    watch: {},
    methods: {
      shgcxfqkFun(params) {
        shgcxfqk(params).then((res) => {
          // console.log("水毁工程修复", res.data)
          this.shgcList = res.data;
        });
      },
      threeluoshiFun(params) {
        threeluoshi(params).then((res) => {
          // console.log("三个责任人落实", res.data)
          this.practicablelist = res.data;
        });
      },
      yhgzqkFun(params) {
        yhZhengg(params).then((res) => {
          // console.log("隐患整改", res.data)
          this.levellist = res.data;
        });
      },
    },
  };
</script>

<style scoped>
  .totalPie,
  .zrrlist {
    width: 100%;
    height: 250px;
    /* height: auto; */
    background: url(../../common/images/contentborder.png) no-repeat center;
    background-size: 100% 100%;
    overflow: hidden;
  }

  .zrrlist {
    margin-top: 15px;
    padding-bottom: 15px;
  }

  .tit {
    padding-bottom: 5px;
    border-bottom: 1px solid #098dc7;
  }

  .tit ul {
    margin-top: 5px;
  }

  .list {
    width: 90%;
    margin: 0 auto;
    height: calc(100% - 75px);
    height: -webkit-calc(100% - 75px);
    height: -moz-calc(100% - 75px);
    overflow: auto;
  }

  .list li {
    width: 100%;
    height: 35px;
    border-top: 1px solid #098dc7;
    cursor: pointer;
  }

  .ddd {
    border-bottom: 1px solid #098dc7;
  }

  .list li div:nth-child(1) {
    width: 30%;
    float: left;
    height: 35px;
  }

  .list li div:nth-child(2) {
    width: 40%;
    float: left;
  }

  .list li div:nth-child(3) {
    width: 30%;
    float: left;
  }

  .titnames {
    line-height: 35px;
    text-align: center;
    color: #fff;
    font-size: 12px;
    border-right: 1px solid #098dc7;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .titnames1 {
    line-height: 35px;
    text-align: center;
    color: #fff;
    font-size: 12px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .sta1 {
    height: 35px;
    overflow: hidden;
    border-radius: 12px;
    margin: 0 auto;
    text-align: center;
    line-height: 35px;
    color: #fff;
    font-size: 12px;
    padding-right: 15px;
  }

  .listb {
    border-bottom: none;
    height: 36px;
    margin-top: 10px;
  }

  .listb li {
    background: rgba(0, 179, 254, 0.5);
    height: 35px;
  }

  .listb li div p {
    line-height: 30px !important;
    margin-top: 0px;
  }

  .list li:nth-child(even) {
    background: rgba(0, 179, 254, 0.1);
  }

  .qdimg {
    width: 30px;
    height: 30px;
    margin-top: 2px;
    margin-left: 40%;
  }
</style>
